module.exports = __webpack_public_path__ + "static/media/HUANJING 1B (HJ-1B).e64f1490.czml";